/* eslint-disable */
import React from 'react';
import { useContext, useState, useEffect } from 'react';
import { MainContext } from '../../../context/ApiContext';
import { Nav, NavbarForm } from './styles';
import { DateTime } from 'luxon';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import useApp from '../../../hooks/useApp';
import useSWR from 'swr';
import { fetcher } from '../../../service/SWRFetcher';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '200px',
  },
}));

const DatePeriodFilter = ({ userId, filters, setFilters }) => {
  const dateNow = DateTime.now().toISODate();
  const dateLastMonth = DateTime.now().plus({ months: -1 }).toISODate();
  const [dates, setDates] = useState({
    date_ini: dateLastMonth,
    date_end: dateNow,
  });
  const [brokerId, setBrokerId] = useState();
  const [technicalTeam, setTechnicalTeam] = useState()

  const { getters } = useContext(MainContext);

  const { data: users } = useSWR(`/users`, fetcher);

  const { data: technicalTeams } = useSWR(`/technical-team`, fetcher);

  function handleSubmit(event, getters) {
    event.preventDefault();

    let filters = {
      date_ini: event.target.elements[0].value,
      date_end: event.target.elements[1].value,
      broker_id: brokerId?.map((b) => ({ id: b.id })) || null,
      technical_team: technicalTeam || null,
      paginate: null,
    };
    setFilters(filters);
  }

  return (
    <Nav>
      <div className="filter">Filtros</div>

      <NavbarForm>
        <form className="form" onSubmit={(e) => handleSubmit(e, getters)}>
          <div className="inputs">
            <div className="date_ini">
              <input
                type="date"
                name="date_ini"
                className="input-form"
                placeholder="Data Inicial"
                value={dates.date_ini}
                onChange={(e) => setDates(e)}
              />
            </div>
            <div className="date_end">
              <input
                type="date"
                name="date_end"
                className="input-form"
                placeholder="Data Final"
                value={dates.date_end}
                onChange={(e) => setDates(e)}
              />
            </div>
          </div>

          <Autocomplete
            multiple
            options={users ? users : []}
            getOptionLabel={(option) => option?.name}
            onChange={(e, value) => setBrokerId(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Corretor" />
            )}
          />

          <Autocomplete
            options={technicalTeams ? technicalTeams : []}
            getOptionLabel={(option) => option?.description}
            onChange={(e, value) => setTechnicalTeam(value)}
            renderInput={(params) => (
              <TextField {...params} className="autocomplete" variant="standard" placeholder="Equipe" />
            )}
          />

          <div>
            <button className="button" type="submit">
              Filtrar
            </button>
          </div>
        </form>
      </NavbarForm>
    </Nav>
  );
};

export default DatePeriodFilter;
